_ = require 'lodash'

module.exports =

  sentByClassMember: (from, students, mentors) ->
    students = _.map students, 'id'
    mentors = _.map mentors, 'id'
    from?.id in students.concat mentors
